<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="440" persistent>
      <v-card class="convenio-card" elevation="12">

        <div class="convenio-header">
          <div class="convenio-icon-wrap">
            <v-icon size="36" color="white">mdi-handshake</v-icon>
          </div>
          <div class="mt-3">
            <div class="text-h6 font-weight-bold white--text">Bienvenido/a</div>
            <div class="caption mt-1 white--text convenio-subtitle">
              Elige la institución con la que vas a trabajar hoy
            </div>
          </div>
        </div>

        <v-card-text class="px-6 pt-5 pb-4 mb-4">
          <div class="convenio-select-label mb-2">
            <v-icon small color="blue darken-4" class="mr-1">mdi-office-building-outline</v-icon>
            Institución de convenio
          </div>

          <v-select
            v-model="$store.state.convenio"
            :items="convenios"
            :loading="loading"
            item-text="nombre"
            item-value="id"
            label="Selecciona una institución"
            outlined
            dense
            prepend-inner-icon="mdi-domain"
            placeholder="Seleccione..."
            return-object
            hide-details="auto"
          ></v-select>

          <v-alert
            v-if="msg"
            type="error"
            dense
            text
            border="left"
            class="mt-3 mb-0 caption">
            {{ msg }}
          </v-alert>
        </v-card-text>

        <v-card-actions class="convenio-actions px-6 pt-3 pb-8 mb-4">
          <div class="caption convenio-hint">
            <v-icon x-small color="blue darken-4" class="mr-1">mdi-information-outline</v-icon>
            Puedes cambiarlo desde la barra superior
          </div>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-4"
            dark
            depressed
            class="convenio-btn"
            min-width="130"
            @click="cerrar()">
            <v-icon small left>mdi-check-circle-outline</v-icon>
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Clave ref="xclavecita"/>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import Clave from './AModalClaveChange.vue'

  export default {
    data() {
      return {
        loading: true,
        dialog: false,
        msg: '',
        convenios: [],
      };
    },
    components:{
      Clave
    },
    methods: {
      openmodal() {
        this.msg = '';
        this.dialog = true;
      },
      setUniversidades(conves) {
        //this.dialog = true;
        this.convenios = conves;
        this.loading = false;
      },
      async getConveniosUniversidades() {
        let vue = this;
        vue.loading = true;
        const sql = gql`query{ getInstituciones(estado:true){id,nombre,tipo,convenio,abreviatura} }`;
        this.$apollo.query({ query: sql }).then(({ data }) => {
          let conves = data.getInstituciones;
          conves = conves.filter(x=>{return x.convenio});
          this.convenios = conves;
          vue.loading = false;
        });
      },
      cerrar() {
        if (this.$store.state.convenio) {
          this.dialog = !this.dialog;
        } else {
          this.msg = 'Debes seleccionar una institucion';
        }
      },
    },
  };
</script>

<style scoped>
.convenio-card {
  overflow: hidden;
  border-radius: 0px !important;
  border: 1px solid #0e4ba5 !important;
}

.convenio-header {
  position: relative;
  background: linear-gradient(135deg, #0d47a1 0%, #1565c0 52%, #1e88e5 100%);
  padding: 32px 24px 26px;
  text-align: center;
  overflow: hidden;
  border-bottom: 1px solid #0b3d86;
}

.convenio-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 68px;
  height: 68px;
  background: rgba(255, 255, 255, 0.16);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.34);
  box-shadow: 0 10px 26px rgba(8, 54, 111, .26);
  margin-bottom: 4px;
}

.convenio-subtitle {
  line-height: 1.4;
  opacity: .88;
}

.convenio-select-label {
  font-size: 12px;
  font-weight: 700;
  color: #0d3f6b;
}

.convenio-actions {
  border-top: 1px solid #d9edf9;
}

.convenio-hint {
  color: #3d6179;
}

.convenio-btn {
  border-radius: 8px;
  text-transform: none;
}
</style>
